import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  storeSelectionLabel: {
    id: '6ed/xl',
    defaultMessage: 'Set default Packing Slip (Optional)',
    description: 'Label for the store selection dropdown in HTML editor',
  },
  storeSelectionPlaceholder: {
    id: 'aurFFX',
    defaultMessage: 'Select store(s) to use this template',
    description: 'Placeholder text for store selection dropdown when no stores selected',
  },
  storesGroupLabel: {
    id: 'Qb166S',
    defaultMessage: 'Stores',
    description: 'Label for dropdown stores group.',
  },
  clearButton: {
    id: '3KlHLZ',
    defaultMessage: 'Clear',
    description: 'Button to clear all selected stores in the store selection dropdown',
  },
  selectAllButton: {
    id: '5xL0jz',
    defaultMessage: 'Select all',
    description: 'Button to select all stores in the store selection dropdown',
  },
});
